<template>
  <w-dialog closeFree width="268px" @ok="onOk" title="提示" top="calc(50vh - 200px)" v-model="visible" class="pop-dialog">
    <div class="dialog-title">{{title}}</div>
  </w-dialog>
</template>

<script>
export default {
  name: "popDialog",
  components: {},
  data() {
    return {
      visible: false,
      type:'',
      title: '',
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    show(type,title) {
      this.visible = true
      this.type = type
      this.title = title
    },
    onOk() {
      this.$emit('ok',this.type)
      this.visible = false
      
  }
}
}
</script>

<style lang="scss" scoped>
.pop-dialog {
  .dialog-title{
    font-size: 14px;
    color: #2F3030;
    text-align: center;
    margin-bottom: 44px;
  }
}
.pop-dialog /deep/{
  .el-dialog__header{
    padding: 16px 0 0;
    height: 54px;
    box-sizing: border-box;
  }
  .el-dialog__body{
    padding: 16px 36px 0 32px;
  }
  .el-form-item{
    margin-bottom: 26px;
  }
  .el-dialog__footer{
    padding: 6px 0 16px;
  }
}
</style>
